import { css } from 'styled-components';

/**
 * Get Styled Component option theme
 * @param options GetOptionThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getOptionTheme = (options)=>{
    const { look } = options;
    return css`
    background-color: ${({ theme })=>theme.option[look].backgroundColor};
    color: ${({ theme })=>theme.option[look].textColor};

    &:hover {
      background-color: ${({ theme })=>theme.option[look].backgroundColorHover};
    }

    &[aria-selected='true'] {
      background-color: ${({ theme })=>theme.option[look].backgroundColorSelected};
    }

    &[aria-disabled='true'] {
      background-color: ${({ theme })=>theme.option[look].backgroundColor};
      color: ${({ theme })=>theme.option[look].textColorDisabled};
    }
  `;
};

export { getOptionTheme };
//# sourceMappingURL=option.js.map
